import { createFeatureSelector } from "@ngrx/store";
import { PersistentNotification } from "./persistent-notification.model";
import * as fromPersistentNotification from "./persistent-notification.reducer";

export const selectPersistentNotificationState = createFeatureSelector<
  PersistentNotification[]
>(fromPersistentNotification.persistentNotificationFeatureKey);
